<div class="guts-m-b-3" data-dgprop-location="Profile Shared">
  <h2 class="h2 font-semibold guts-m-t-1-half guts-m-b-quart guts-p-h-1-quart">
    {{ sharedHeader }}
  </h2>
  <p class="par--light par--small guts-m-b-3 guts-p-h-1-quart">
    {{ i18n.dgRecommendationsOverview_Description }}
  </p>

  <div class="l_flex">
    <dgx-profile-filter-bar
      *ngIf="!isEmpty()"
      (filterUpdated)="applyFilter($event)"
      [filter]="activeFilter"
      [placeholder]="i18n.dgRecommendationsOverview_Filter"
    ></dgx-profile-filter-bar>
  </div>

  <div [hidden]="showSearchResults" *ngIf="!isLoading">
    <!-- Incomplete -->
    <div class="grid guts-p-t-2" *ngIf="sharedItems.incomplete.length">
      <h1 class="h3 grid__col-12 guts-p-v-0">
        {{ this.i18n.dgRecommendationsOverview_Incomplete }}
      </h1>
      <dgx-lazy-chunk
        class="grid"
        [list]="sharedItems.incomplete"
        [trackBy]="trackRecommendationById"
        [options]="{ threshold: 0.5 }"
        [loadingTemplateHeight]="29"
        [chunkSize]="6"
        [rowLength]="rowLength"
      >
        <ng-template let-context>
          <dgx-profile-shared-tile
            class="tile__wrapper updated-content-cards"
            [section]="i18n.dgRecommendationsOverview_Incomplete"
            [itemIndex]="context.itemIndex"
            [lazyChunkIndex]="context.lazyChunkIndex"
            [item]="context.localItem"
            (dismissOpportunity)="handleDismissOpportunity($event)"
          ></dgx-profile-shared-tile>
        </ng-template>
      </dgx-lazy-chunk>
    </div>
    <!-- Completed -->
    <div class="grid guts-p-t-2" *ngIf="sharedItems.completed.length">
      <h1 class="h3 grid__col-12 guts-p-v-0">
        {{ this.i18n.Core_Completed }}
      </h1>
      <dgx-lazy-chunk
        class="grid"
        [list]="sharedItems.completed"
        [trackBy]="trackRecommendationById"
        [options]="{ threshold: 0.5 }"
        [loadingTemplateHeight]="29"
        [chunkSize]="6"
        [rowLength]="rowLength"
      >
        <ng-template let-context>
          <!--
            Linter Error
            [actions]="tileActionsConfig"
            Can't bind to 'actions' since it isn't a known property of 'dgx-profile-shared-tile'.
          -->
          <dgx-profile-shared-tile
            class="tile__wrapper updated-content-cards"
            [section]="i18n.Core_Completed"
            [itemIndex]="context.itemIndex"
            [lazyChunkIndex]="context.lazyChunkIndex"
            [item]="context.localItem"
            (dismissOpportunity)="handleDismissOpportunity($event)"
          ></dgx-profile-shared-tile>
        </ng-template>
      </dgx-lazy-chunk>
    </div>
  </div>

  <!-- Filtered State -->
  <div class="guts-p-t-2" *ngIf="showSearchResults && !isLoading">
    <dgx-lazy-chunk
      class="grid"
      [list]="filteredSharedItems"
      [trackBy]="trackRecommendationById"
      [options]="{ threshold: 0.5 }"
      [chunkSize]="6"
      [loadingTemplateHeight]="29"
      [rowLength]="rowLength"
    >
      <ng-template let-item>
        <!--
          Linter error
            [actions]="tileActionsConfig"
            Property 'tileActionsConfig' does not exist on type 'ProfileSharedComponent'
        -->
        <dgx-profile-shared-tile
          class="tile__wrapper updated-content-cards"
          [item]="item.localItem"
          (dismissOpportunity)="handleDismissOpportunity($event)"
        ></dgx-profile-shared-tile>
      </ng-template>
    </dgx-lazy-chunk>
    <div
      class="center-text"
      *ngIf="!filteredSharedItems || !filteredSharedItems.length"
    >
      <dgx-profile-empty-state
        [title]="i18n.ProfileCtrl_NoExactMatches"
        [description]="i18n.ProfileCtrl_NoExactMatchesHelp"
      ></dgx-profile-empty-state>
    </div>
  </div>
  <!-- Empty State -->
  <div *ngIf="isEmpty()" class="grid l_flex-justify-center">
    <dgx-profile-empty-state
      [title]="i18n.dgRecommendationsOverview_EmptyStateTitle"
      [description]="i18n.dgRecommendationsOverview_EmptyStateDescription"
    ></dgx-profile-empty-state>
  </div>
</div>

<!-- Is loading state -->
<ul class="grid" *ngIf="isLoading">
  <li
    *ngFor="let i of [1, 2, 3, 4, 5, 6]"
    [class.grid__col-lg-3]="rowLength === 4"
    [class.grid__col-lg-4]="rowLength === 3"
    class="grid__col-xs-6 grid__col-md-4"
    data-dgat="profile-shared-4a3"
  >
    <div class="tile__wrapper">
      <dgx-skeleton type="tile" layout="random"></dgx-skeleton>
    </div>
  </li>
</ul>
<div class="footer-glasses guts-m-t-8"></div>
